import { useQuery } from '@tanstack/react-query';
import { agentsApi, AIAgentQuery, AIAgentResponse } from '../services/agentsApi';
import type { ListResponse } from '@troia-v3/types';

/**
 * Hook para listar agentes com paginação e filtros
 *
 * @example
 * const { data, isLoading, error } = useAgents({
 *   page: 1,
 *   limit: 12,
 *   status: 'active',
 *   search: 'support'
 * });
 */
export const useAgents = (query?: AIAgentQuery) => {
  return useQuery<ListResponse<AIAgentResponse>, Error>({
    queryKey: ['ai-agents', query],
    queryFn: () => agentsApi.getAll(query),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
